<div class="entity-card">
  <h1>{{ count }}</h1>
  <p>{{ label }}</p>
</div>
